module.exports = __webpack_public_path__ + "static/img/escala0a10-csat.68bbb4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/escala0a10-csat.png
// module id = 1I7m
// module chunks = 1